var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4845_85221)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.3926,
    y: 24.6855,
    width: 61.4444,
    height: 61.4444,
    rx: 16.3852,
    fill: "#FF7F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5399 41.9836C72.6737 46.1173 73.3998 52.3682 70.7182 57.2456C70.4078 57.8108 70.0516 58.3576 69.6494 58.8803C69.4428 59.1492 69.2238 59.4116 68.993 59.6669C68.8469 59.8286 68.6957 59.9877 68.5399 60.1434C67.3864 61.2969 66.0679 62.1853 64.6603 62.8077C59.9495 64.893 54.2413 64.0046 50.3802 60.1434C46.519 56.2823 45.6307 50.574 47.7159 45.8632C48.3383 44.4556 49.2267 43.1371 50.3802 41.9836C50.5359 41.8278 50.695 41.6766 50.8567 41.5305C51.112 41.2997 51.3744 41.0807 51.6433 40.8741C52.166 40.4719 52.7128 40.1157 53.278 39.8053C58.1553 37.1237 64.4062 37.8498 68.5399 41.9836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8577 41.5303L68.9939 59.6666C68.8478 59.8284 68.6967 59.9874 68.5409 60.1432C67.3874 61.2967 66.0689 62.185 64.6612 62.8075L47.7168 45.8629C48.3392 44.4553 49.2276 43.1368 50.3811 41.9833C50.5369 41.8275 50.6959 41.6764 50.8577 41.5303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2773 39.8057L70.7175 57.2459C70.407 57.8111 70.0509 58.3579 69.6487 58.8807L51.6426 40.8745C52.1653 40.4722 52.7121 40.1161 53.2773 39.8057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1165 56.202C72.7801 54.5656 73.1165 52.8367 73.1166 51.0633C73.1166 49.2899 72.7801 47.561 72.1165 45.9245C71.4293 44.2299 70.42 42.7097 69.1165 41.4063C67.8131 40.1029 66.293 39.0935 64.5983 38.4063C62.9619 37.7427 61.233 37.4062 59.4596 37.4062C57.6862 37.4062 55.9573 37.7427 54.3209 38.4063C52.6263 39.0935 51.1061 40.1029 49.8027 41.4063C48.4993 42.7097 47.49 44.2299 46.8028 45.9245C46.1392 47.561 45.8027 49.2899 45.8027 51.0632C45.8027 52.8366 46.1392 54.5655 46.8028 56.202C47.298 57.4232 47.9606 58.5538 48.7799 59.578L47.2917 61.0662L49.4568 63.2313L50.945 61.7431C51.9692 62.5624 53.0997 63.2249 54.321 63.7202C55.9574 64.3838 57.6863 64.7202 59.4597 64.7202C61.233 64.7202 62.9619 64.3838 64.5984 63.7202C66.293 63.033 67.8132 62.0236 69.1166 60.7202C70.42 59.4168 71.4293 57.8966 72.1165 56.202ZM59.4597 63.0883C56.2477 63.0883 53.2279 61.8375 50.9567 59.5662C48.6855 57.295 47.4347 54.2753 47.4347 51.0633C47.4347 47.8513 48.6855 44.8315 50.9567 42.5603C53.2279 40.2891 56.2477 39.0383 59.4597 39.0383C62.6716 39.0383 65.6914 40.2891 67.9626 42.5603C70.2338 44.8315 71.4846 47.8513 71.4846 51.0633C71.4846 54.2753 70.2338 57.295 67.9626 59.5662C65.6914 61.8375 62.6716 63.0883 59.4597 63.0883Z",
    fill: "#23333A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9226 64.5705L40.5061 72.9871C39.947 73.5461 39.0405 73.5461 38.4814 72.9871L37.5364 72.042C36.9773 71.483 36.9775 70.5766 37.5366 70.0175L45.9531 61.601L46.512 61.4707L49.0621 64.0208L48.9226 64.5705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9701 63.523L48.9226 64.5705L45.9531 61.601L47.0006 60.5535C47.1644 60.3897 47.4296 60.3897 47.5933 60.5535L49.9702 62.9303C50.1339 63.094 50.1339 63.3592 49.9701 63.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3975 45.8555V56.4551M54.0977 51.1553H64.6973",
    stroke: "black",
    strokeWidth: 1.81708,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4845_85221",
    x: -31.6074,
    y: -31.3145,
    width: 173.445,
    height: 173.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4845_85221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4845_85221",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoomIcon.94e63ea3b46dd24b75bc44ec2bf342bd.svg";
export { ForwardRef as ReactComponent };